var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bases-list" },
    [
      _vm._m(0),
      _vm._l(_vm.basesData, function (base, index) {
        return _c("div", { key: index, staticClass: "base-item" }, [
          _c("p", [_vm._v(_vm._s(base.baseName))]),
          _c("p", [
            _vm._v(_vm._s(base.orgName) + " | " + _vm._s(base.department)),
          ]),
          _c("p", [_vm._v(_vm._s(base.year || "-"))]),
          _c("p", [_vm._v(_vm._s(base.fields || "-"))]),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "bases-list-header" }, [
      _c("li", [_vm._v("基地名称")]),
      _c("li", [_vm._v("依托单位")]),
      _c("li", [_vm._v("批准时间")]),
      _c("li", [_vm._v("研究领域")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }